import type { SxStyle } from '@aibees/shared/theme';

export const summary: SxStyle = {
  padding: '0 !important',
};

export const details: SxStyle = {
  padding: '0 !important',
};
